var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 10.4233L10.4233 11L6.5 7.07669L2.57656 11L2 10.4233L5.92344 6.5L2 2.57669L2.57656 2L6.5 5.92331L10.4233 2L11 2.57669L7.07679 6.5L11 10.4233Z","fill":"currentColor","stroke":"currentColor","strokeWidth":"2"}));
}

Cross.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
